@if (!isDestroyed) {
    <af-full-table
        class="w-100 h-100"
        [filterFields]="filterFields"
        [filterEvent]="tableEvent.filter"
        [pageEvent]="tableEvent.page"
        (tableUpdateListener)="loadOrganizations($event)"
        [dataSource]="dataSource"
        [totalElements]="totalElements"
        (emptyStateClickListener)="buttonClickStream.next('tabOrganizations')"
        [showImport]="false"
        [showExport]="false"
        emptyStateIconName="ic_empty_state_data_no_created"
        emptyStateTitleTranslationKey="i18n_af_emptyStateTitleDataNotCreatedOrganizations"
        emptyStateSubtitleTranslationKey="i18n_af_emptyStateSubtitleDataNotCreatedOrganizations"
        emptyStateButtonLabel="i18n_af_buttonCreateOrganization"
        totalElementsTranslationKey="i18n_af_labelTotalElementsOrganizations"
        placeholderContext="organizations"/>
}
